import { useQuery } from "@tanstack/react-query";
import { listMyTickets } from "../api/supportApi";

/**
 * Live unread-ticket count for the right-rail Support badge. Polls the tenant
 * server every 5s; agent (John + Claude) replies posted from Frappe Desk surface
 * on the next poll and bump the badge. Mount once (the app rail is global).
 */
export function useSupportUnread(): number {
  const { data } = useQuery({
    queryKey: ["support", "tickets"],
    queryFn: listMyTickets,
    refetchInterval: 5000,
  });

  return (data ?? []).filter((tk) => tk.unread).length;
}
